import { FormButtons } from './styles'

export default function FormButton({ children, ...props }) {
  return <FormButtons {...props}>{children}</FormButtons>
}
